<div class="create-team">
  <div class="create-team__header">
    @if (step==1 ) {
      <span>Whats your team called?</span>
    }
    @if (step==2) {
      <span>Team created successfully</span>
    }
    @if (step==3) {
      <span>Send invitations</span>
    }
    <mds-icon (click)="closeDialog()" [key]="icons.CLOSE" [pathColors]="['#547080']" class="pointer"></mds-icon>
  </div>
  <mat-dialog-content class="dialog-content">
    @if (step===1) {
      <div class="step-1">
        <div class="form-container">
          <mat-label>Team name:</mat-label>
          <mat-form-field appearance="outline">
            <input
              [formControl]="nameControl"
              autocomplete="off"
              matInput
              placeholder='Ex. "Acme" or "Acme Manufacturing"' required="true"
              >
            <mat-hint>We'll use this to name your makersite workspace.
              This will also be the address where you will log in to your
              workspace -ex:"acmemanufacturing.makersite.app".
            </mat-hint>
            @if (nameControl.touched && nameControl.hasError('pattern')) {
              <mat-error>
                Empty spaces or special characters are not allowed!
              </mat-error>
            }
            @if (nameControl.touched && nameControl.hasError('required')) {
              <mat-error>
                Name is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        @if (nameControl.touched && nameControl.valid) {
          <span
            [class.available]="available"
            [class.unavailable]="!available"
            >
            {{ available ? 'Available' : 'Unavailable' }}
          </span>
        }
      </div>
    }
    @if (step === 2) {
      <div>
        <p>Your team {{ teamInfo?.team_name }} has been set up and is ready for some collaborative work. You reach your
          new
        team site at {{ teamInfo?.team_name }}.makersite.app. Happy collaborating!</p>
      </div>
    }
    @if (step===3) {
      <div>
        <div class="create-team__invite">
          <h6>Your Makersite workspace ready to go. Invite coworkers and associates to user Makersite with you.</h6>
          <div class="add-new">
            <p>Add email addresses below to invite team members:</p>
            <span class="add-icon">
              <mds-icon
                (click)="addInvitations()"
                [key]="icons.PLUS"
                [pathColors]="['#547080']"
              ></mds-icon>
            </span>
          </div>
        </div>
        @for (invitation of invitationCount; track invitation) {
          <div>
            <app-invite-team [data]="invitation"></app-invite-team>
          </div>
        }
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (step ===1) {
      <div class="create-team__actions">
        <mds-button (click)="closeDialog()" [type]="'secondary'" class="close" role="button">Close
        </mds-button>
        <mds-button (click)="createTeamsite()" [disabled]="nameControl.invalid && !available" [type]="'primary'"
          role="button">
          Next
        </mds-button>
      </div>
    }
    @if (step ===2) {
      <div class="create-team__actions">
        <a (click)="dialogRef.close();" [href]="getNewTeamURL" aria-label="Log In To Your New Team Site"
        role="button" target="_blank">Log In To Your New Team Site</a>
        <mds-button (click)="nextStep()" [type]="'primary'" role="button">Stay here</mds-button>
      </div>
    }
    @if (step ===3) {
      <div class="create-team__actions">
        <mds-button (click)="skipInvitations()" [type]="'secondary'" role="button">Skip Inviting For Now
        </mds-button>
        <mds-button (click)="sendInvitations()" [disabled]="!invitationCount.length" [type]="'secondary'" role="button">
          Send
          Invitations
        </mds-button>
      </div>
    }
  </mat-dialog-actions>
</div>



